import { render, staticRenderFns } from "./ChartPetugasTMA.vue?vue&type=template&id=ada5534a&"
import script from "./ChartPetugasTMA.vue?vue&type=script&lang=js&"
export * from "./ChartPetugasTMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports